export default __webpack_public_path__ + "static/media/term-condition.cc2b4517.svg";